<template>
  <div>
    <div class="tabs">
      <div role="tablist">
        <a :href="tab.href"
           v-for="tab in tabs"
           role="tab"
           :tabindex="tab.isActive ? 0 : -1"
           :aria-selected="tab.isActive"
           :aria-controls="'tab-content-' + tab.aliasSlug"
           :id="'tab-' + tab.aliasSlug"
           v-on:keydown="focusTab($event)"
           @click="selectTab(tab, $event)">
          <span>{{ tab.name }}</span>
        </a>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tabs',
    model: {
      prop: 'tabSelected',
      event: 'tab-selected'
    },
    data () {
      return {
        tabs: [],
        tabFocus: Number
      }
    },
    created () {
      this.tabs = this.$children
    },
    mounted () {
      this.tabFocus = this.tabs.findIndex((item) => item.isActive === true)
    },
    methods: {
      selectTab (selectedTab, event) {
        if (!selectedTab.hash) {
          event.preventDefault()
        }
        this.tabs.forEach(tab => {
          tab.isActive = (tab.name === selectedTab.name)
        })
        this.$emit('tab-selected', {
          id: selectedTab.aliasSlug
        })
      },
      focusTab (e) {
        if (e.keyCode === 39 || e.keyCode === 37) {
          let focusedTab = document.getElementById('tab-' + this.tabs[this.tabFocus].aliasSlug)
          focusedTab.setAttribute('tabindex', '-1')
          if (e.keyCode === 39) {
            this.tabFocus++
            if (this.tabFocus >= this.tabs.length) {
              this.tabFocus = 0
            }
          } else if (e.keyCode === 37) {
            this.tabFocus--
            if (this.tabFocus < 0) {
              this.tabFocus = this.tabs.length - 1
            }
          }
          focusedTab = document.getElementById('tab-' + this.tabs[this.tabFocus].aliasSlug)
          focusedTab.setAttribute('tabindex', '0')
          focusedTab.focus()
        }
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.hash !== from.hash) {
          const activeTab = this.tabs.find((item) => item.alias === to.hash.replace('#', ''))
          if (activeTab) {
            this.selectTab(activeTab)
          }
        }
      }
    }
  }
</script>

<style src="@/assets/scss/components/tabs/tabs.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// Tabs.vue?189ded1e